import bell from './audios/bell.wav'
import school from './audios/school.mp3'
import software from './audios/software.wav'
import contactUs from './images/contact-us.jpg'
import listingImage from './images/listingImages.jpg'
import logo from './images/logo.png'
import onBoardImage1 from './images/onboard-image-1.png'
import onBoardImage2 from './images/onboard-image-2.png'
import paytrailMobile from './images/paytrail-mobile.png'
import paytrailWeb from './images/paytrail-web.png'
import priceTag from './images/price-tag.png'
import registerToSellAtVshop from './images/register-to-sell-at-vshop.png'
import shoppingBag from './images/shopping-bag.png'
import thumbnail from './images/thumnail.jpg'
import confetti from './json/confetti.json'
import done from './json/done.json'
import empty from './json/empty.json'
import loading from './json/loading.json'
import notFound from './json/not-found.json'
import shoppingLoader from './json/shopping-loader.json'

const audios = {
    school,
    bell,
    software,
}

const images = {
    logo,
    registerToSellAtVshop,
    paytrailWeb,
    paytrailMobile,
    onBoardImage1,
    onBoardImage2,
    shoppingBag,
    priceTag,
    contactUs,
    thumbnail,
    listingImage,
}

const json = {
    confetti,
    done,
    empty,
    loading,
    notFound,
    shoppingLoader,
}

export default {
    audios,
    images,
    json,
}
